var map = {
	"./ARCity.mp4": 8121,
	"./ARCity.webm": 3909,
	"./DataPioneers.mp4": 787,
	"./DataPioneers.webm": 6908,
	"./DataStream.mp4": 3683,
	"./DataStream.webm": 1036,
	"./DigitalTwin.mp4": 3949,
	"./DigitalTwin.webm": 3680,
	"./NOE-Map.mp4": 781,
	"./NOE-Map.webm": 5222,
	"./Narrativ.mp4": 5761,
	"./Narrativ.webm": 5750,
	"./PublicPrivacy.mp4": 2469,
	"./PublicPrivacy.webm": 6214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3584;